import React from 'react';
import './ScheduleColumnTitle.less';

export const ScheduleColumnTitle = ({text}) => {
	return <span className="schedule-column-title">{text}</span>
}
